"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.STICKYTYPES = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./StickyBar.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var STICKYTYPES = {
  DYNAMICTOP: "dynamicTop",
  DYNAMICBOTTOM: "dynamicBottom",
  STATICTOP: "staticTop",
  STATICBOTTOM: "staticBottom"
};
exports.STICKYTYPES = STICKYTYPES;

var StickyBar =
/*#__PURE__*/
function (_Component) {
  _inherits(StickyBar, _Component);

  function StickyBar(props) {
    var _this;

    _classCallCheck(this, StickyBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StickyBar).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "determineSticky", function () {
      var type = _this.props.type;
      var scroll = window.scrollY;
      var _this$state = _this.state,
          top = _this$state.top,
          height = _this$state.height,
          fixed = _this$state.fixed;
      var newFixed = false;

      if (type === STICKYTYPES.DYNAMICTOP) {
        if (scroll > top) {
          newFixed = true;
        } else {
          newFixed = false;
        }
      } else if (type === STICKYTYPES.DYNAMICBOTTOM) {
        if (scroll + document.documentElement.clientHeight > top + height) {
          newFixed = true;
        } else {
          newFixed = false;
        }
      }

      if (fixed !== newFixed) {
        _this.setState({
          fixed: newFixed
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function () {
      _this.determineSticky();
    });

    _this.state = {
      fixed: false
    };
    return _this;
  }

  _createClass(StickyBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var type = this.props.type;
      var el = document.querySelector('.stickyBar');

      if (el) {
        var height = el.offsetHeight;

        if (type !== STICKYTYPES.STATICBOTTOM && type !== STICKYTYPES.STATICTOP) {
          this.setState({
            top: el.offsetTop,
            height: height
          });
          window.addEventListener('scroll', this.handleScroll);

          if (this.props.setStickyHeight) {
            this.props.setStickyHeight(el.offsetHeight);
          }

          this.determineSticky();
        } else if (type === STICKYTYPES.STATICTOP) {
          document.body.style.paddingTop = "".concat(height, "px");
        } else if (type === STICKYTYPES.STATICBOTTOM) {
          document.body.style.paddingBottom = "".concat(height, "px");
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var type = this.props.type;
      var _this$state2 = this.state,
          fixed = _this$state2.fixed,
          height = _this$state2.height;

      switch (type) {
        case STICKYTYPES.DYNAMICTOP:
          if (fixed) {
            document.body.style.paddingTop = "".concat(height, "px");
          } else {
            document.body.style.paddingTop = 0;
          }

          break;

        case STICKYTYPES.DYNAMICBOTTOM:
          if (fixed) {
            document.body.style.paddingBottom = "".concat(height, "px");
          } else {
            document.body.style.paddingBottom = 0;
          }

          break;

        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          children = _this$props.children,
          wrapperClass = _this$props.wrapperClass;
      var fixed = this.state.fixed;
      var stickyClass = "stickyBar ".concat(wrapperClass);

      switch (type) {
        case STICKYTYPES.DYNAMICTOP:
          stickyClass = "".concat(stickyClass, " dynamicTop");

          if (fixed) {
            stickyClass = "".concat(stickyClass, " fixed-sticky");
          }

          break;

        case STICKYTYPES.DYNAMICBOTTOM:
          stickyClass = "".concat(stickyClass, " dynamicBottom");

          if (fixed) {
            stickyClass = "".concat(stickyClass, " fixed-sticky");
          }

          break;

        case STICKYTYPES.STATICTOP:
          stickyClass = "".concat(stickyClass, " staticTop");
          break;

        case STICKYTYPES.STATICBOTTOM:
          stickyClass = "".concat(stickyClass, " staticBottom");
          break;

        default:
          console.warn("Type is not defined into STICKYTYPES enum, please use one value from that ENUM");
          return null;
      }

      return _react.default.createElement("div", {
        className: stickyClass
      }, children);
    }
  }]);

  return StickyBar;
}(_react.Component);

StickyBar.propTypes = {
  wrapperClass: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  type: _propTypes.default.string,
  setStickyHeight: _propTypes.default.func
};
StickyBar.defaultProps = {
  type: STICKYTYPES.DYNAMICTOP,
  wrapperClass: '',
  setStickyHeight: function setStickyHeight() {}
};
var _default = StickyBar;
exports.default = _default;

//# sourceMappingURL=index.js.map